import api from '../api/api';

const getAllCourses = async () => {
  try {
    const response = await api.get('/courses/all');
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

const getCourseById = async (courseId) => {
  try {
    const response = await api.get(`/courses/${courseId}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

const courseService = {
  getAllCourses,
  getCourseById,
};

export default courseService;